<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import './assets/fonts/editfont.css'
export default {
  name: 'App',
  // provide () {
  //   return {
  //     reload: this.reload
  //   }
  // },
  data () {
    return {
      // isRouterAlive: true
    }
  },
  watch: {
    '$route' (to) {
      // 菜单高亮控制
      this.$store.commit('setMenuActive', to.meta.name)
      // 面包屑导航控制
      this.$store.commit('setBreadList', to.matched)
      // 全局path控制setFullPath
      this.$store.commit('setFullPath', to.fullPath)
      // 页面路由权限控制, 拿到权限列表才会生效
      if (this.$conf.needPagePermission) {
        let page = this.$base.getUserPagePermission()
        let ToPathList = ['/login', '/bigScreen', '/bigScreenPage', '/bigScreenGarden', '/join', '/home', '/entrust']
        if (!page || !page.length || ToPathList.indexOf(to.path) > -1) {
          return
        }
        if ((page.indexOf(to.path) < 0)) {
          this.$router.push('/404')
        }
      }
    }
  }
  // methods: {
  //   reload () {
  //     this.isRouterAlive = false
  //     this.$nextTick(() => (this.isRouterAlive = true))
  //   }
  // }
}
</script>
<style>
  @import "./assets/fonts/editfont.css";

/*body*/
  .el-table th.gutter{
  display: table-cell!important;
}
</style>
